import React from 'react';
import GlobalStyles from '../components/GlobalStyles';
import { LandingPage } from '../components/LandingPage';

export const MarketingLayout: React.FC = () => {
    return (
        <div className="min-h-screen selection:bg-indigo-500/30">
            <GlobalStyles />
            <LandingPage />
        </div>
    );
};
